import { useEffect, useRef } from "react";
import { graphql, useFragment } from "react-relay";
import { HeaderFragment$key } from "./__generated__/HeaderFragment.graphql";
import { FormattedMessage } from "react-intl";
import NavItem from "./NavItem";
import * as Drawer from "./Drawer";
import { useLocation } from "react-router";
import NavItems from "./NavItems";
import { Menu01Icon } from "@/icons";
import { LogoButton } from "./LogoButton";
import { UserMenuNavBar, UserMenuDrawer } from "./UserMenu";

const HeaderFragment = graphql`
  fragment HeaderFragment on Query {
    viewer @ifAllowed {
      id
      ...UserMenuFragment
    }
  }
`;

interface Props {
  query: HeaderFragment$key;
}

export default function Header({ query }: Props) {
  const data = useFragment(HeaderFragment, query);
  const location = useLocation();
  const closeRef = useRef<HTMLButtonElement>(null);

  useEffect(() => {
    if (closeRef.current) {
      closeRef.current.click();
    }
  }, [location]);

  return (
    <header className="flex w-full items-center h-16 bg-white backdrop-blur-md sticky top-0 z-50 px-4">
      <div className="container mx-auto max-w-(--breakpoint-xl) flex flex-row gap-10">
        <LogoButton />

        <nav className="hidden lg:flex flex-row space-x-1 items-center w-full">
          <NavItems />
        </nav>

        <div className="hidden lg:flex grow-0 items-center pr-2 gap-3">
          <UserMenuNavBar viewer={data.viewer} />
        </div>

        <div className="lg:hidden w-full" />

        <div className="lg:hidden">
          <Drawer.Root snapPoints={[0.7, 1]} fadeFromIndex={0}>
            <Drawer.Trigger asChild>
              <div className="inline-block px-4 py-2 hover:cursor-pointer">
                <Menu01Icon className="w-6 h-6 text-grey-900" />
              </div>
            </Drawer.Trigger>
            <Drawer.Content>
              <div className="flex flex-col py-4 space-y-2">
                <NavItem to="/" vertical>
                  <FormattedMessage defaultMessage="Home" />
                </NavItem>
                <NavItems vertical />
                <div className="px-4">
                  <div className="border-t border-grey-200 pt-6">
                    <UserMenuDrawer viewer={data.viewer} />
                  </div>
                </div>
              </div>
            </Drawer.Content>
            <Drawer.Close asChild>
              <button ref={closeRef} className="hidden" />
            </Drawer.Close>
          </Drawer.Root>
        </div>
      </div>
    </header>
  );
}
